import { createContext, useState, useEffect, useContext } from 'react';

const InstallableContext = createContext();

export const InstallableProvider = ({ children }) => {
	const [promptable, setPromptable] = useState(null);
	const [isInstalled, setIsInstalled] = useState(false);

	const promptToInstall = () => {
		if (promptable) {
			return promptable.prompt();
		}
		return Promise.reject(new Error('Tried installing before browser sent "beforeinstallprompt" event'));
	};

	useEffect(() => {
		const ready = (e) => {
			e.preventDefault();
			setPromptable(e);
		};

		window.addEventListener('beforeinstallprompt', ready);

		return () => {
			window.removeEventListener('beforeinstallprompt', ready);
		};
	}, []);

	useEffect(() => {
		const onInstall = () => {
			setIsInstalled(true);
		};

		window.addEventListener('appinstalled', onInstall);

		return () => {
			window.removeEventListener('appinstalled', onInstall);
		};
	}, []);

	return (
		<InstallableContext.Provider
			value={{
				promptable,
				promptToInstall,
				isInstalled,
			}}
		>
			{children}
		</InstallableContext.Provider>
	);
};

export function useInstallable() {
	const context = useContext(InstallableContext);
	return context;
}
